export default __webpack_public_path__ + "static/mobilescreen-f4014955e8ab3bcc3cafea2ed6674ae5.webp";